import createSiteProperty from '../base-saving-actions/create-site-property';

const createSiteProperties = (properties) =>
  properties.map(({ name, value }) => createSiteProperty(name, value));

export default createSiteProperties;
